
const inMemoryCookies = {};

export const CookieNames = {
    csrf: '__Secure-yw_rf',
};

class Cookie {
    /**
     * Gets the value of the given cookie.
     *
     * @param {string} cname Name of a cookie
     */
    static getValue(cname) {
        if (typeof document === 'undefined') {
            return inMemoryCookies[cname] ?? null;
        }
        const name = `${cname}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    /**
     * Deletes the given cookie.
     *
     * @param {string} cname Name of a cookie
     */
    static delete(cname) {
        if (typeof document === 'undefined') {
            delete inMemoryCookies[cname];
        } else {
            document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
        }
    }
}

export default Cookie;
